import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { BillingProcessDetailsDialogComponent } from './billing-process-details-dialog/billing-process-details-dialog.component';
import { MasterBillingConceptComponent } from './billing-concept/master-billing-concept.component';
import { MasterBillingConceptModalComponent } from './billing-concept-modal/master-billing-concept-modal.component';
import { BillingService } from './services/billing.service';
import { BillingProcessComponent } from './billing-process/billing-process.component';
import { BillingComponent } from './billing/billing.component';
import { BillingFailedProvidersComponent } from './billing-failed-providers/billing-failed-providers.component';
import { RouterModule } from '@angular/router';
import { BillingRoutingModule } from './billing-routing.module';
import { BillingDownloadComponent } from './billing-download/billing-download.component';
import { BillerComponent } from './biller_provider/biller.component';
import { ClientCodesListComponent } from './client-codes-list/client-codes-list.component';
import { BillsListComponent } from './bills-list/bills-list.component';
import { ActivityLogComponent } from './event-registry/activity-log.component';
import { DescriptionArrayPipePipe } from './pipes/description-array-pipe.pipe';


@NgModule({
    declarations: [
        BillingComponent,
        BillingProcessComponent,
        BillingFailedProvidersComponent,
        BillingProcessDetailsDialogComponent,
        MasterBillingConceptComponent,
        MasterBillingConceptModalComponent,
        BillingDownloadComponent,
        BillerComponent,
        ClientCodesListComponent,
        BillsListComponent,
        ActivityLogComponent,
        DescriptionArrayPipePipe
    ],
    imports: [
        CommonModule,
        BillingRoutingModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatPaginatorModule,
        MatSelectModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatExpansionModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    providers: [BillingService],
    exports: []
})
export class BillingModule { }